import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

import { THEME } from '../../config/constants';

import styles from './styles.module.css';

import data from '../../data';

const HeaderBraun = ({ theme, isRoom, onBackToTimeline, className }) => {
  const { general } = data;

  const HundredLogo = ({ color }) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 73.58 73.8">
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <g>
              <path
                d="M3.42,33.52h0A3.42,3.42,0,0,1,0,30.1V4A3.42,3.42,0,0,1,6.84,4V30.1a3.42,3.42,0,0,1-3.42,3.42"
                style={{ fill: color }}
              />
              <path
                d="M25.9,6.84A10.22,10.22,0,1,0,36.12,17.06,10.23,10.23,0,0,0,25.9,6.84m0,27.28A17.06,17.06,0,1,1,43,17.06,17.08,17.08,0,0,1,25.9,34.12"
                style={{ fill: color }}
              />
              <path
                d="M56.52,6.84A10.22,10.22,0,1,0,66.74,17.06,10.23,10.23,0,0,0,56.52,6.84m0,27.28A17.06,17.06,0,1,1,73.58,17.06,17.08,17.08,0,0,1,56.52,34.12"
                style={{ fill: color }}
              />
              <g>
                <path
                  d="M4,49.26a2.06,2.06,0,0,1-2.25,1.48,10.14,10.14,0,0,1-1.1-.06V49.2a6.11,6.11,0,0,0,1,.06.77.77,0,0,0,.7-.82,1.06,1.06,0,0,0-.08-.4L0,41.9H2l1.48,4.48h0L4.89,41.9H6.75Z"
                  style={{ fill: color }}
                />
                <path
                  d="M9,45.61c.05,1.15.59,1.65,1.6,1.65A1.47,1.47,0,0,0,12,46.42h1.58a2.93,2.93,0,0,1-3.06,2.2,3.2,3.2,0,0,1-3.34-3.44,3.29,3.29,0,0,1,3.34-3.46c2.23,0,3.32,1.87,3.18,3.89Zm2.92-1.14c-.16-.91-.56-1.39-1.43-1.39A1.41,1.41,0,0,0,9,44.47Z"
                  style={{ fill: color }}
                />
                <path
                  d="M14.78,43.91c.1-1.67,1.61-2.19,3.08-2.19,1.3,0,2.87.29,2.87,1.86V47A3.41,3.41,0,0,0,21,48.44H19.13a2.7,2.7,0,0,1-.12-.63,3,3,0,0,1-2.21.81c-1.25,0-2.22-.62-2.22-2,0-3,4.43-1.38,4.35-2.85,0-.76-.53-.89-1.16-.89s-1.13.28-1.19,1Zm4.15,1.33a3.49,3.49,0,0,1-1.49.38c-.56.1-1.07.3-1.07,1s.52.84,1.11.84a1.33,1.33,0,0,0,1.45-1.51Z"
                  style={{ fill: color }}
                />
                <path
                  d="M22.25,41.9H24v1.21h0a2.3,2.3,0,0,1,2.09-1.39,1.28,1.28,0,0,1,.39.07v1.67a3.16,3.16,0,0,0-.65-.07c-1.33,0-1.77.94-1.77,2.1v2.95H22.25Z"
                  style={{ fill: color }}
                />
                <path
                  d="M28.69,46.31c0,.78.68,1.11,1.37,1.11.51,0,1.18-.21,1.18-.84s-.76-.75-2-1c-1.05-.24-2.07-.58-2.07-1.75,0-1.67,1.44-2.1,2.85-2.1s2.74.48,2.88,2.09H31.15c0-.7-.58-.89-1.22-.89-.41,0-1,.07-1,.61s1,.74,2,1S33,45.13,33,46.34c0,1.72-1.51,2.28-3,2.28s-3-.57-3.07-2.31Z"
                  style={{ fill: color }}
                />
              </g>
              <g>
                <path
                  d="M.71,56.63c.1-1.67,1.61-2.19,3.08-2.19,1.3,0,2.87.29,2.87,1.86v3.4a3.29,3.29,0,0,0,.23,1.46H5.06a2.78,2.78,0,0,1-.12-.64,3,3,0,0,1-2.2.81c-1.26,0-2.23-.62-2.23-2,0-3,4.43-1.38,4.35-2.84,0-.76-.53-.89-1.16-.89s-1.13.28-1.19,1ZM4.86,58a3.76,3.76,0,0,1-1.49.38c-.56.1-1.06.3-1.06,1s.51.83,1.1.83a1.33,1.33,0,0,0,1.45-1.5Z"
                  style={{ fill: color }}
                />
                <path
                  d="M8.18,54.62h1.7v.91h0a2.3,2.3,0,0,1,2-1.09c1.91,0,2.39,1.07,2.39,2.69v4H12.52v-3.7c0-1.07-.31-1.6-1.16-1.6S10,56.4,10,57.73v3.43H8.18Z"
                  style={{ fill: color }}
                />
                <path
                  d="M15.81,54.62h1.7v.91h0a2.3,2.3,0,0,1,2-1.09c1.91,0,2.39,1.07,2.39,2.69v4H20.15v-3.7c0-1.07-.31-1.6-1.16-1.6s-1.39.54-1.39,1.87v3.43H15.81Z"
                  style={{ fill: color }}
                />
                <path
                  d="M25.28,53.6H23.49V52.12h1.79Zm-1.79,1h1.79v6.54H23.49Z"
                  style={{ fill: color }}
                />
                <path
                  d="M30.43,61.16h-2l-2.24-6.54h1.89l1.38,4.46h0l1.38-4.46h1.79Z"
                  style={{ fill: color }}
                />
                <path
                  d="M35,58.32c0,1.15.59,1.66,1.61,1.66A1.46,1.46,0,0,0,38,59.13H39.6a2.92,2.92,0,0,1-3.06,2.2,3.19,3.19,0,0,1-3.34-3.44,3.28,3.28,0,0,1,3.34-3.45c2.23,0,3.32,1.87,3.18,3.88Zm2.92-1.14c-.16-.91-.56-1.39-1.43-1.39A1.41,1.41,0,0,0,35,57.18Z"
                  style={{ fill: color }}
                />
                <path
                  d="M40.91,54.62h1.71v1.21h0a2.3,2.3,0,0,1,2.09-1.39,1.27,1.27,0,0,1,.39.06v1.67a3.1,3.1,0,0,0-.64-.06c-1.33,0-1.78.93-1.78,2.1v2.95H40.91Z"
                  style={{ fill: color }}
                />
                <path
                  d="M47.35,59c0,.77.68,1.1,1.38,1.1.5,0,1.17-.2,1.17-.83s-.76-.75-2-1c-1-.24-2.08-.58-2.08-1.74,0-1.67,1.44-2.1,2.85-2.1s2.74.48,2.88,2.09H49.81c-.05-.7-.58-.89-1.22-.89-.41,0-1,.06-1,.61s1,.73,2,1,2.08.62,2.08,1.84c0,1.72-1.51,2.27-3,2.27s-3-.57-3.07-2.3Z"
                  style={{ fill: color }}
                />
                <path
                  d="M52.8,56.63c.1-1.67,1.61-2.19,3.07-2.19s2.88.29,2.88,1.86v3.4A3.46,3.46,0,0,0,59,61.16H57.15a2.78,2.78,0,0,1-.12-.64,3,3,0,0,1-2.21.81c-1.25,0-2.22-.62-2.22-2,0-3,4.43-1.38,4.35-2.84,0-.76-.53-.89-1.16-.89s-1.13.28-1.19,1ZM57,58a3.81,3.81,0,0,1-1.49.38c-.56.1-1.07.3-1.07,1s.52.83,1.11.83A1.33,1.33,0,0,0,57,58.63Z"
                  style={{ fill: color }}
                />
                <path
                  d="M60.27,54.62H62v1.21h0a2.3,2.3,0,0,1,2.09-1.39,1.27,1.27,0,0,1,.39.06v1.67a3.2,3.2,0,0,0-.65-.06c-1.33,0-1.77.93-1.77,2.1v2.95H60.27Z"
                  style={{ fill: color }}
                />
                <path
                  d="M69.29,62A2.07,2.07,0,0,1,67,63.46c-.36,0-.73,0-1.1-.06V61.92A9.24,9.24,0,0,0,67,62a.77.77,0,0,0,.7-.82,1.15,1.15,0,0,0-.08-.41l-2.3-6.13h1.92l1.48,4.47h0l1.43-4.47H72Z"
                  style={{ fill: color }}
                />
              </g>
              <g>
                <path
                  d="M3.38,73.69H2.6V69H.9v-.63c.9,0,1.71-.23,1.88-1.22h.6Z"
                  style={{ fill: color }}
                />
                <path
                  d="M6.08,72.12a1.12,1.12,0,0,0,1.2,1c1,0,1.43-.83,1.47-2.52l0,0a1.7,1.7,0,0,1-1.5.9,2,2,0,0,1-2.07-2.18,2,2,0,0,1,2.15-2.12c1.21,0,2.23.65,2.23,3.12,0,2.25-.68,3.51-2.26,3.51a1.78,1.78,0,0,1-2-1.68Zm1.19-4.26C6.34,67.86,6,68.6,6,69.4a1.32,1.32,0,1,0,1.28-1.54Z"
                  style={{ fill: color }}
                />
                <path
                  d="M10.65,69.48a2,2,0,0,1,2.1-2.31,1.85,1.85,0,0,1,2,1.88,2.61,2.61,0,0,1-1.58,2.23c-.81.49-1.69.92-1.83,1.72h3.34v.69H10.47A3.06,3.06,0,0,1,12.3,71C13.4,70.33,14,70,14,69a1.19,1.19,0,0,0-1.26-1.18c-.91,0-1.3.84-1.27,1.62Z"
                  style={{ fill: color }}
                />
                <path
                  d="M18.46,73.69h-.78V69H16v-.63c.89,0,1.7-.23,1.87-1.22h.6Z"
                  style={{ fill: color }}
                />
              </g>
              <path
                d="M22.31,69.78a.6.6,0,0,1,.59.59.63.63,0,0,1-.58.59.61.61,0,0,1-.6-.59A.6.6,0,0,1,22.31,69.78Z"
                style={{ fill: color }}
              />
              <g>
                <path
                  d="M25.28,69.48a2,2,0,0,1,2.1-2.31,1.85,1.85,0,0,1,2,1.88,2.61,2.61,0,0,1-1.58,2.23C27,71.77,26.15,72.2,26,73h3.35v.69H25.1A3.08,3.08,0,0,1,26.93,71c1.1-.69,1.66-1.07,1.66-2a1.19,1.19,0,0,0-1.26-1.18c-.91,0-1.29.84-1.27,1.62Z"
                  style={{ fill: color }}
                />
                <path
                  d="M32.72,67.17c2.05,0,2.17,1.88,2.17,3.32s-.12,3.31-2.17,3.31-2.17-1.88-2.17-3.31S30.68,67.17,32.72,67.17Zm0,5.94c1.34,0,1.35-1.65,1.35-2.63s0-2.62-1.35-2.62-1.34,1.65-1.34,2.62S31.39,73.11,32.72,73.11Z"
                  style={{ fill: color }}
                />
                <path
                  d="M35.86,69.48A2,2,0,0,1,38,67.17a1.85,1.85,0,0,1,2,1.88,2.61,2.61,0,0,1-1.58,2.23c-.81.49-1.68.92-1.83,1.72h3.35v.69H35.68A3.08,3.08,0,0,1,37.51,71c1.1-.69,1.66-1.07,1.66-2a1.19,1.19,0,0,0-1.26-1.18c-.91,0-1.29.84-1.27,1.62Z"
                  style={{ fill: color }}
                />
                <path
                  d="M43.85,73.69h-.78V69h-1.7v-.63c.9,0,1.71-.23,1.88-1.22h.6Z"
                  style={{ fill: color }}
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  };

  const MainLogo = ({ color }) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.47 38.81">
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <g id="layer1">
              <g id="g2414">
                <path
                  id="path7"
                  d="M7.57,34.17H4.81V25.91H7.49c1.84,0,2.69,1.37,2.69,3.82,0,3.37-1,4.44-2.69,4.44M4.81,14H7.39c1.33,0,2.4,1,2.4,3.67s-1.24,3.67-2.4,3.67H4.81Zm7.11,9.38v0c1.06-.73,2.75-2,2.75-6.07,0-5.26-2.77-7.65-6.51-7.65H0V38.52H8.12c4.61,0,6.85-3.38,6.85-8.43,0-4.7-1.86-6-3.05-6.72Z"
                  style={{ fill: color }}
                />
                <path
                  id="path9"
                  d="M23.61,14h2.58c1.33,0,2.4,1,2.4,3.67s-1.24,3.67-2.4,3.67H23.61V14m9.86,15c0-3.75-1.16-4.8-2.75-5.71v.1c1.06-.73,2.74-2,2.74-6.07,0-5.26-2.76-7.65-6.5-7.65H18.8V38.52h4.81V25.91h2.53c1.33,0,2.28,1.13,2.28,3.68v8.93h4.81l.23-9.67Z"
                  style={{ fill: color }}
                />
                <path
                  id="path11"
                  d="M42.65,7.13c0-2.18,2-2.46,3.09-2.46s3.09.28,3.09,2.46V21.56H42.64V7.11m3-7.11c-2,0-7.79.46-7.79,6.3V38.52h4.81V25.91h6.19V38.52h4.59V6.3c0-5.85-5.81-6.3-7.8-6.3Z"
                  style={{ fill: color }}
                />
                <path
                  id="path13"
                  d="M67.86,9.63V32.38c0,1.16-1,1.93-2.41,1.93s-2.4-.77-2.4-1.93V9.63H58.23v23.5c0,4.47,4.58,5.67,7.11,5.67s7.11-1.2,7.11-5.68V9.63H67.86"
                  style={{ fill: color }}
                />
                <path
                  id="path15"
                  d="M86.89,38.52V15.79c0-1.16-1-1.94-2.41-1.94s-2.41.78-2.41,1.94V38.52H77.26V15c0-4.48,4.58-5.67,7.11-5.67s7.1,1.2,7.1,5.67V38.52H86.89"
                  style={{ fill: color }}
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  };

  MainLogo.propTypes = {
    color: PropTypes.string.isRequired,
  };

  HundredLogo.propTypes = {
    color: PropTypes.string.isRequired,
  };

  return (
    <>
      <div
        className={`${className} ${styles.header} ${
          isMobile ? styles.isMobile : ''
        }`}
      >
        <div className={styles.logo}>
          <MainLogo color={theme === THEME.BLACK ? '#000' : '#fff'} />
        </div>
        {isRoom ? (
          <div
            className={styles.backContainer}
            onClick={() => {
              onBackToTimeline();
            }}
          >
            <div className={styles.backToTimeline}>
              <div className={styles.backToText}>
                {general.backTo}
                <br />
                <b className={styles.backBold}>{general.timeline}</b>
              </div>
              <div className={styles.timelineWhiteBack}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
                  <g id="Layer_2" data-name="Layer 2">
                    <g id="Layer_1-2" data-name="Layer 1">
                      <g>
                        <path
                          id="Layer0_45_MEMBER_0_1_STROKES"
                          data-name="Layer0 45 MEMBER 0 1 STROKES"
                          d="M41,21a19.26,19.26,0,0,1-5.85,14.14A19.26,19.26,0,0,1,21,41,19.29,19.29,0,0,1,6.85,35.15,19.26,19.26,0,0,1,1,21,19.29,19.29,0,0,1,6.85,6.85,19.29,19.29,0,0,1,21,1,19.26,19.26,0,0,1,35.15,6.85,19.29,19.29,0,0,1,41,21Z"
                          style={{
                            fill: 'none',
                            stroke: 'white',
                            strokeLinecap: 'round',
                            strokeLinejoin: 'round',
                            strokeWidth: '2px',
                          }}
                        />
                        <path
                          id="Layer0_47_MEMBER_0_1_STROKES"
                          data-name="Layer0 47 MEMBER 0 1 STROKES"
                          d="M14,21.42a3.19,3.19,0,0,1-3.21,3.2,3.2,3.2,0,0,1-2.27-5.47,3.06,3.06,0,0,1,2.27-.94,3.06,3.06,0,0,1,2.27.94A3.1,3.1,0,0,1,14,21.42Z"
                          style={{
                            fill: 'none',
                            stroke: 'white',
                            strokeWidth: '2px',
                          }}
                        />
                        <path
                          id="Layer0_47_MEMBER_1_1_STROKES"
                          data-name="Layer0 47 MEMBER 1 1 STROKES"
                          d="M24.24,21.42a3.22,3.22,0,0,1-5.48,2.27,3.21,3.21,0,0,1,4.54-4.54A3.1,3.1,0,0,1,24.24,21.42Z"
                          style={{
                            fill: 'none',
                            stroke: 'white',
                            strokeWidth: '2px',
                          }}
                        />
                        <path
                          id="Layer0_47_MEMBER_2_1_STROKES"
                          data-name="Layer0 47 MEMBER 2 1 STROKES"
                          d="M34.43,21.42a3.21,3.21,0,1,1-.94-2.27A3.08,3.08,0,0,1,34.43,21.42Z"
                          style={{
                            fill: 'none',
                            stroke: 'white',
                            strokeWidth: '2px',
                          }}
                        />
                        <path
                          id="Layer0_54_1_STROKES"
                          data-name="Layer0 54 1 STROKES"
                          d="M24.22,21.56h3.83M14,21.56h3.83"
                          style={{
                            fill: 'none',
                            stroke: 'white',
                            strokeLinecap: 'round',
                            strokeLinejoin: 'round',
                            strokeWidth: '2px',
                          }}
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.hundredLogo}>
            <HundredLogo color={theme === THEME.BLACK ? '#000' : '#FFF'} />
          </div>
        )}
      </div>
    </>
  );
};

HeaderBraun.defaultProps = {
  theme: 'light',
  isRoom: false,
  onBackToTimeline: () => {},
  className: '',
};

HeaderBraun.propTypes = {
  theme: PropTypes.string,
  isRoom: PropTypes.bool,
  onBackToTimeline: PropTypes.func,
  className: PropTypes.string,
};

export default HeaderBraun;
